import { useRef } from 'react';

/**
 * A key for a detail mask that changes with the record in the path.
 *
 * The router keeps a mask mounted when the path moves to another record of
 * the same kind — the command palette from one supplier to the next — so the
 * store still held the record before, the mask showed it under the new
 * heading and could save its conditions onto the new one (#2326 R-243).
 * Keyed with this, the mask is built anew: its cleanup empties the store and
 * the new record, its conditions and its option lists are fetched.
 *
 * The step from /new to the record just saved keeps the key: that is the
 * same record, and building the mask again would throw away what is on it.
 */
export const usePaloRecordKey = (id: string | undefined): string => {
    const key = useRef(id ?? '');
    const last = useRef(id);

    if (id !== last.current) {
        const fromNew = undefined === last.current || isNaN(+last.current);
        const toSaved = undefined !== id && !isNaN(+id);

        if (!(fromNew && toSaved)) {
            key.current = id ?? '';
        }

        last.current = id;
    }

    return key.current;
};
